import tbPopUpItem from './tb-pop-up-item.component'

export default angular
  .module('tb.pop-up-item', [])
  .component('tbPopUpItem', tbPopUpItem)
  .name
